function ProjectModal({ project, onClose }) {
  if (!project) return null;

  function handleOverlayClick(event) {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }

  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
    >
      <div className="relative max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-[2rem] bg-white p-6 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-xl font-bold text-black transition hover:bg-pink-100"
          aria-label="Close modal"
        >
          ×
        </button>

        <div className="overflow-hidden rounded-[1.5rem]">
          <img
            src={project.image}
            alt={`Screenshot of ${project.title}`}
            className="h-72 w-full object-cover object-top"
          />
        </div>

        <div className="pt-8">
          <h3 className="text-3xl font-extrabold text-black">
            {project.title}
          </h3>

          <p className="mt-5 leading-relaxed text-gray-600">
            {project.fullDescription}
          </p>

          {project.featureSections && (
            <div className="mt-8">
              <h4 className="text-lg font-extrabold text-black">
                Key features
              </h4>

              <div className="mt-4 grid gap-5">
                {project.featureSections.map((section) => (
                  <div
                    key={section.title}
                    className="rounded-3xl border border-pink-100 bg-pink-50/40 p-5"
                  >
                    <h5 className="text-base font-extrabold text-purple-700">
                      {section.title}
                    </h5>

                    <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                      {section.items.map((item) => (
                        <li
                          key={item}
                          className="flex gap-3 text-sm text-gray-700"
                        >
                          <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-pink-500"></span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}

          {project.technologies && (
            <div className="mt-8">
              <h4 className="text-lg font-extrabold text-black">
                Technologies used
              </h4>

              <div className="mt-4 flex flex-wrap gap-3">
                {project.technologies.map((technology) => (
                  <span
                    key={technology}
                    className="rounded-full border border-pink-100 bg-white px-4 py-2 text-sm font-semibold text-purple-700 shadow-sm"
                  >
                    {technology}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
            <a
              href={project.github}
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-purple-500 px-6 py-3 text-center font-semibold text-purple-700 transition hover:bg-purple-600 hover:text-white"
            >
              GitHub
            </a>

            {project.live !== "#" && (
              <a
                href={project.live}
                target="_blank"
                rel="noreferrer"
                className="rounded-full bg-gradient-to-r from-pink-500 to-purple-600 px-6 py-3 text-center font-semibold text-white shadow-md transition hover:scale-105"
              >
                Live Site
              </a>
            )}

            {project.prototypeWeb && (
              <a
                href={project.prototypeWeb}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-pink-400 px-6 py-3 text-center font-semibold text-pink-600 transition hover:bg-pink-500 hover:text-white"
              >
                Web Prototype
              </a>
            )}

            {project.prototypeMobile && (
              <a
                href={project.prototypeMobile}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-indigo-400 px-6 py-3 text-center font-semibold text-indigo-600 transition hover:bg-indigo-500 hover:text-white"
              >
                Mobile Prototype
              </a>
            )}

            {project.styleGuide && (
              <a
                href={project.styleGuide}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-gray-400 px-6 py-3 text-center font-semibold text-gray-700 transition hover:bg-gray-700 hover:text-white"
              >
                Style Guide
              </a>
            )}

            {project.moodboard && (
              <a
                href={project.moodboard}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-purple-400 px-6 py-3 text-center font-semibold text-purple-600 transition hover:bg-purple-600 hover:text-white"
              >
                Moodboard
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectModal;